import type * as THREE from 'three';

/**
 * A small interior drawn INSTEAD of the city (Sid's back room, docs/WEAPONS.md §6). While `scene` is
 * set the render system hands this scene and camera to the post stack in place of `ctx.scene` /
 * `ctx.camera`: the city costs no draw calls at all, its sun, fog and shadows don't touch the room, and
 * the grade and bloom still apply. The simulation keeps running underneath (it must, online). Shared and
 * mutable, like `viewState`; whoever sets it clears it.
 */
export const sceneOverride: { scene: THREE.Scene | null; camera: THREE.Camera | null } = { scene: null, camera: null };
